/**
 * Stock Urgency Handler for Dawn 15.4
 * Updates the low stock badge when variants are changed.
 */

class StockUrgency {
  constructor() {
    this.init();
  }

  init() {
    // Listen for the custom 'variantChange' event emitted by Dawn's global.js
    window.addEventListener('message', (event) => {
      // Dawn often communicates via postMessage for some internal components
    });

    // Most reliable method for Dawn: Observe the URL change or the Variant ID input
    document.addEventListener('change', (event) => {
      if (event.target.matches('variant-selects, variant-radios')) {
        this.updateUrgencyBadge();
      }
    });
  }

  async updateUrgencyBadge() {
    // Small delay to ensure the DOM has updated the variant ID input
    setTimeout(async () => {
      const sectionId = document.querySelector('[data-section]').dataset.section;
      const variantId = new URLSearchParams(window.location.search).get('variant');
      
      if (!variantId) return;

      // Fetch the product page with the new variant to get the updated Liquid-rendered badge
      // This is cleaner than hardcoding logic in JS
      try {
        const response = await fetch(`${window.location.pathname}?variant=${variantId}&section_id=${sectionId}`);
        const text = await response.text();
        const html = new DOMParser().parseFromString(text, 'text/html');
        
        const newBadge = html.querySelector(`#ProductStockUrgency-${sectionId}`);
        const currentBadge = document.querySelector(`#ProductStockUrgency-${sectionId}`);

        if (newBadge && currentBadge) {
          currentBadge.innerHTML = newBadge.innerHTML;
        }
      } catch (e) {
        console.error('Stock Urgency Update Failed:', e);
      }
    }, 50);
  }
}

// Initialize on load
document.addEventListener('DOMContentLoaded', () => {
  new StockUrgency();
});